function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 64h3.937c.309 0 .562.337.562.75v1.5c0 .412-.253.75-.562.75H4.5c-1.242 0-2.25 1.344-2.25 3v12c0 1.656 1.008 3 2.25 3h3.937c.309 0 .562.338.562.75v1.5c0 .412-.253.75-.562.75H4.5C2.016 88 0 85.312 0 82V70c0-3.312 2.016-6 4.5-6zm10.832 1.219-.919 1.225a.923.923 0 0 0 .009 1.069l5.3 6.862H8.062c-.309 0-.562.338-.562.75v1.75c0 .412.253.75.562.75h11.662l-5.3 6.856a.939.939 0 0 0-.009 1.069l.919 1.225a.47.47 0 0 0 .8 0l7.706-10.25a.937.937 0 0 0 0-1.063l-7.706-10.25a.473.473 0 0 0-.802.007z",
    transform: "translate(0 -64)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/sign-out-icon.98c7e739.svg";
export { ForwardRef as ReactComponent };